import { FC, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  FinancialProjectForSelectFragment,
  SubprojectForSelectFragment,
} from 'generated/resources/graphql'

import {
  FinancialDocumentAssociation,
  InvoiceForm,
} from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import { FinancialProjectSelector } from 'modules/project_management/components/selectors/FinancialProjectSelector'

export type ProjectSelectorType = 'project'

interface ProjectSelectorProps {
  form: FormikProps<InvoiceForm>
  initialSelectedProject?: FinancialProjectForSelectFragment | null | undefined
  initialSelectedSubproject?: SubprojectForSelectFragment | null | undefined
  onClear: (isSubproject?: boolean, projectAssociation?: FinancialDocumentAssociation) => void
  readOnly: boolean
}

const ProjectsSelector: FC<ProjectSelectorProps> = ({
  form,
  initialSelectedProject,
  initialSelectedSubproject,
  onClear,
  readOnly,
}) => {
  const [selectedProject, setSelectedProject] = useState<FinancialProjectForSelectFragment | null>(
    initialSelectedProject || null
  )

  const [selectedSubproject, setSelectedSubproject] = useState<SubprojectForSelectFragment | null>(
    initialSelectedSubproject || null
  )

  const handleOnChangeProject = (value: FinancialProjectForSelectFragment | null) => {
    if (!value) {
      setSelectedProject(null)
      setSelectedSubproject(null)
      onClear()
    } else {
      setSelectedProject(value)
      form.setFieldValue('associations', [
        {
          resource: { id: value.id, type: 'project' },
        },
      ])
    }
  }
  const handleOnChangeSubproject = (value: SubprojectForSelectFragment | null) => {
    setSelectedSubproject(value)

    if (!value) {
      if (selectedProject) {
        form.setFieldValue('associations', [
          {
            resource: { id: selectedProject.id, type: 'project' },
          },
        ])
      }
    } else {
      if (!selectedProject) {
        return
      }
      const projectAssociation = {
        resource: { id: selectedProject.id, type: 'project' },
      }
      const subprojectAssociation = {
        resource: { id: value.id, type: 'subproject' },
      }
      form.setFieldValue('associations', [subprojectAssociation, projectAssociation])
    }
  }

  return (
    <Box gap="s16">
      <FinancialProjectSelector
        value={selectedProject}
        onChange={handleOnChangeProject}
        subprojectValue={selectedSubproject}
        onChangeSubproject={handleOnChangeSubproject}
        projectDisabled={readOnly}
        subprojectDisabled={readOnly}
        hideSearchIcon={readOnly}
      />
    </Box>
  )
}
export default ProjectsSelector
